<div [class]="props.class ?? 'riquadro'">

  <ng-container *ngIf="!props.formReadOnly; else readOnlyTemplate">

    <!-- ===== VERSIONE STANDARD ===== -->
    <form [formGroup]="form" (ngSubmit)="onSubmit(model)">

      <formly-form [form]="form" [fields]="(fields$ | async) || []" [model]="model" [options]="options">
      </formly-form>

      <div class="d-flex justify-content-between align-items-center mt-3">

        <!-- Bottone rosso -->
        <div>
          <button *ngIf="props.labelButton && (props.showButtons ?? true) && showSaveButton" [disabled]="loading"
            type="button" class="btn btn-danger" (click)="onClickButton()">
            {{ props.labelButton }}
          </button>
        </div>

        <!-- Reset + Salva -->
        <div class="text-end">
          <button *ngIf="props.showButtons ?? true" type="button" class="btn btn-secondary"
            (click)="options.resetModel?.()">
            Reset
          </button>

          <button *ngIf="(props.showButtons ?? true) && showSaveButton" [disabled]="loading" type="submit"
            class="btn btn-primary ms-2">
            {{ props.type === 'is_filter' ? 'Filtra' : 'Salva' }}
          </button>
        </div>

      </div>

    </form>

  </ng-container>


  <!-- ===== TEMPLATE READONLY ===== -->
  <ng-template #readOnlyTemplate>

    <form [formGroup]="form" class="modern-form-container">

      <div class="modern-form-body">
        <formly-form [form]="form" [fields]="(fields$ | async) || []" [model]="model" [options]="options">
        </formly-form>
      </div>

    </form>

  </ng-template>

</div>